import { Context, ContextBi, contextToBiEvent, getChatbotView } from '@wix/wix-chatbot-common/browser';

import { TRootState } from '../../common/reducers';
import { selectWidgetSessionId } from '../../common/selectors/widgetSession';
import { widgetSDK } from '../../sdk/widgetSDK';
import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';

const userId = renderModel.getUserId();

const getContext = async (): Promise<Context | undefined> => {
  try {
    const context = await widgetSDK.getContext();

    if (!context || !Object.keys(context).length) {
      const error = new Error(`Context is empty`);
      logger.error({
        error,
        message: 'Context is empty',
        callParams: { userId },
      });
      return;
    }

    return context;
  } catch (error) {
    logger.error({
      message: 'fail to get Context',
      error,
    });
  }
};

export const getRuntimeDataForBi = async (
  state: TRootState,
): Promise<{
  userPriorityClass: string;
  sessionId: string | undefined;
  metaSiteId: string | undefined;
  chatbotView: string | undefined;
  contextBi: ContextBi | undefined;
  placement: string | undefined;
}> => {
  return Promise.all([getContext(), widgetSDK.getWidgetPlacement()])
    .then(([context, placement]) => {
      return {
        userPriorityClass: context?.careProfile?.userPriorityClass || '',
        sessionId: selectWidgetSessionId(state),
        metaSiteId: context?.metaSiteId,
        chatbotView: (context && getChatbotView(context)) || undefined,
        contextBi: context && contextToBiEvent(context),
        placement,
      };
    })
    .catch((error) => {
      logger.error({
        message: 'Fail to get SDK data for bi event',
        error,
      });
      return {
        userPriorityClass: '',
        sessionId: undefined,
        metaSiteId: undefined,
        chatbotView: undefined,
        contextBi: undefined,
        placement: undefined,
      };
    });
};
